import {defineStore} from 'pinia';
import Api from '@services/api';
import {removeEmptyParams} from '@utils';

export const useRoleStore = defineStore('role', {
  state: () => ({roles: undefined}),
  actions: {
    async all() {
      if (this.isFilled()) return this.roles;
      let roles = await Api(true, false)
        .get('/roles', {params: removeEmptyParams({})})
        .then((res) => {
          return res.data;
        });
      this.$patch({
        roles: roles,
      });
      return this.roles;
    },
    clear() {
      this.$patch({
        roles: undefined,
      });
    },
    isFilled() {
      return this.roles !== undefined;
    },
  },
});
